export const brl = (v) =>
  (Number(v) || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

export const fmtDate = (iso) => {
  if (!iso) return "-";
  try {
    return new Date(iso.length === 10 ? iso + "T12:00:00" : iso).toLocaleDateString("pt-BR");
  } catch {
    return "-";
  }
};

export const phoneDigits = (p) => String(p || "").replace(/\D/g, "");

export const numBR = (v) => {
  if (v === null || v === undefined || v === "") return 0;
  if (typeof v === "number") return isNaN(v) ? 0 : v;
  let s = String(v).trim().replace(/[^\d.,-]/g, "");
  if (s.includes(",")) s = s.replace(/\./g, "").replace(",", ".");
  const n = parseFloat(s);
  return isNaN(n) ? 0 : n;
};

export const statusLabel = {
  rascunho: "Rascunho",
  enviado: "Enviado",
  aprovado: "Aprovado",
  recusado: "Recusado",
  agendada: "Agendada",
  em_andamento: "Em andamento",
  concluida: "Concluída",
  cancelada: "Cancelada",
};

export const statusColor = {
  rascunho: "bg-slate-100 text-slate-700 border-slate-300",
  enviado: "bg-sky-50 text-sky-700 border-sky-200",
  aprovado: "bg-green-50 text-green-700 border-green-200",
  recusado: "bg-red-50 text-red-700 border-red-200",
  agendada: "bg-sky-50 text-sky-700 border-sky-200",
  em_andamento: "bg-amber-50 text-amber-700 border-amber-200",
  concluida: "bg-green-50 text-green-700 border-green-200",
  cancelada: "bg-slate-100 text-slate-500 border-slate-300",
};
